import { z } from 'zod';
import { PaymentStatus, PaymentMethod } from './enums.js';
export const WalletSchema = z.object({
    userId: z.string().uuid(),
    balanceFcfa: z.number().int().nonnegative().default(0),
    pendingFcfa: z.number().int().nonnegative().default(0),
    totalEarnedFcfa: z.number().int().nonnegative().default(0),
    totalSpentFcfa: z.number().int().nonnegative().default(0),
    updatedAt: z.string().datetime(),
});
export const TransactionSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    type: z.enum(['credit', 'debit', 'commission', 'refund', 'withdrawal']),
    amountFcfa: z.number().int(),
    balanceAfterFcfa: z.number().int(),
    status: z.nativeEnum(PaymentStatus),
    paymentMethod: z.nativeEnum(PaymentMethod).nullable(),
    paymentReference: z.string().nullable(),
    rideId: z.string().uuid().nullable(),
    description: z.string(),
    metadata: z.record(z.unknown()).optional(),
    createdAt: z.string().datetime(),
});
export const RechargeSchema = z.object({
    amountFcfa: z.number().int().min(500).max(1000000),
    paymentMethod: z.nativeEnum(PaymentMethod),
    paymentReference: z.string().optional(),
});
export const WithdrawSchema = z.object({
    amountFcfa: z.number().int().min(1000).max(1000000),
    paymentMethod: z.nativeEnum(PaymentMethod),
    phoneNumber: z.string().optional(),
});
export const WalletStatsSchema = z.object({
    totalRecharges: z.number().int(),
    totalWithdrawals: z.number().int(),
    totalCommissions: z.number().int(),
    currentBalance: z.number().int(),
    pendingBalance: z.number().int(),
});
